<template>
  <Dialog :dialog="dialog" :title="dialog.title">
    <v-alert :value="true" type="error" v-if="dialog.errors.length > 0">
      <div v-for="(error, index) in dialog.errors" :key="index">{{ error }}</div>
    </v-alert>
    <template slot="actions">
      <v-btn flat color="accent" @click="dialog.status=false">Ок</v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from '@/components/fragments/Dialog'

export default {
  components: {Dialog},
  props: {
    dialog: Object,
    title: String
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fragments/ErrorDialog.vue